<ng-container
  [ngSwitch]="
    hideFieldIfNoInitialValue &&
    fieldControl &&
    !fieldControl.value &&
    !visibilityTriggered &&
    !fieldControl.dirty
  "
>
  <button
    *ngSwitchCase="true"
    type="button"
    tabindex="0"
    class="field-toggle-action"
    [attr.data-e2e-id]="toggleActionE2eId"
    (click)="showField()"
    trackable
    [trackingObject]="trackingObject"
    [trackingAction]="triggerTrackingAction"
  >
    {{ fieldTriggerLabel }}
  </button>

  <div
    *ngSwitchDefault
    class="textarea-field"
    [ngClass]="{
      'has-value': !!fieldControl?.value,
      'has-placeholder': !!placeholder,
      condensed: condensed,
      'visibility-triggered': visibilityTriggered,
      'no-max-height': noMaxHeight
    }"
  >
    <label
      *ngIf="label"
      class="textarea-label field-label"
      [ngClass]="{
        'sr-text': hideLabel,
        disabled: fieldControl?.disabled
      }"
      [attr.for]="fieldId"
      [attr.type]="'textarea'"
    >
      {{ label }}
    </label>

    <div class="textarea-wrapper" [ngClass]="{ 'has-left-icon': !!leftIcon }">
      <textarea
        #textarea
        class="textarea"
        [ngClass]="{ full: textarea.value.length === maxlength }"
        [focusable]="focusableTrigger$"
        tabindex="0"
        [i2gDynamicResize]="true"
        [attr.maxlength]="maxlength <= 0 ? null : maxlength"
        [attr.id]="fieldId"
        [attr.placeholder]="placeholder"
        [formControl]="fieldControl"
        [autoComplete]="options?.autoComplete"
        [attr.data-e2e-id]="textareaE2eId"
        [attr.autocomplete]="removeNativeAutocomplete ? 'i2g' : 'off'"
        trackable
        [trackingObject]="trackingObject"
        [trackingAction]="trackingAction"
        [readonly]="readOnly"
        (onBlur)="onBlur.emit(fieldControl.value)"
        (onFocus)="onFocus.emit(fieldControl.value)"
        (onAutoCompleteFetchStart)="onAutoCompleteFetchStart.emit()"
        (onAutoCompleteFetchEnd)="onAutoCompleteFetchEnd.emit($event)"
        (onAutoCompleteSet)="onAutoCompleteSet.emit($event)"
        (onAutoCompleteHide)="onAutoCompleteHide.emit()"
        (onAutoCompleteDestroy)="onAutoCompleteDestroy.emit()"
      >
      </textarea>

      <app-icon *ngIf="rightIcon" class="icon right-icon" [icon]="rightIcon">
      </app-icon>

      <div
        *ngIf="maxlength > 0 && maxlength - textarea.value.length < 100"
        class="counter"
      >
        {{ textarea.value.length }}/{{ maxlength }}
      </div>

      <app-error-message
        [fieldControl]="fieldControl"
        [errorMessage]="errorMessage"
      >
      </app-error-message>
    </div>
  </div>

  <div *ngIf="description" class="textarea-field">
    <p class="description">
      {{ description }}
    </p>
  </div>
</ng-container>
